import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from '~/core/classes/auth/auth.guard';

//******************************************************************************
//  App Pages
//******************************************************************************
import { HomeComponent } from '~/pages/home/home.component';

export const routes: any[] = [
    {
        path: '',
        title: 'Digital Core - Smart Design',
        isNav: true,
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        redirectTo: 'notfound',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class AppRouting { }
